import { Injector, ProviderToken } from '@angular/core';

export class ServiceLocator {
    static injector: Injector;

    static get<T>(service: ProviderToken<T>) {
        return ServiceLocator.injector.get(service);
    }
}
